// Module
var code = "<div class=\"content-element [[ marginTop ? '-m-top-' + marginTop : '' ]] [[ marginBottom ? '-m-bottom-' + marginBottom : '' ]] text-style [[ isLead ? '-lead' : '-para' ]]\"> </div> ";
// Exports
export default code;